import React from "react";
import "./textInput.scss";

const TextInput = ({ placeholder, type, inputValue, setInputValue, isDisabled = false }) => {
    return (
        <div className="input">
            <input
                placeholder={placeholder}
                type={type}
                autoComplete="true"
                className="text-input"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                disabled={isDisabled}
            />
        </div>
    );
};

export default TextInput;
